import {isCookieLawSetup} from '../../utils';

const reducer = (state = {cookieLaw: isCookieLawSetup()}, action) => {
    switch (action.type) {
        case 'SET_COOKIE_LAW':
			return {...state, cookieLaw: action.cookieLaw}
			break;
		default: // need this for default case
      		return state ;
    }
}

export default reducer;